import { BaseModel } from './base-model';
import { IMOsCurrentScheduleState, ScheduleEntry, SimplifiedPortCall } from './types/voyage-schedules-model.types';

export abstract class VoyageSchedulesModelBase extends BaseModel {
    abstract get currentScheduleStates(): IMOsCurrentScheduleState[];
    abstract getScheduleFor(imoNo: number, includeNumBefore?: number, relativeFrom?: number): Promise<ScheduleEntry[] | null>;
    abstract getDatesFromSchedule(imoNo: number): { toDate: Date, fromDate: Date, currentTime: Date };
    abstract changePortCall(portCall: SimplifiedPortCall): Promise<void>
    abstract deletePortCall(portCall: SimplifiedPortCall): Promise<void>
    abstract addPortCall(portCall: SimplifiedPortCall): Promise<void>
}

let VoyageSchedulesModel: VoyageSchedulesModelBase | null = null;

export function setVoyageSchedulesModel(model: VoyageSchedulesModelBase) {
    VoyageSchedulesModel = model;
}

export { VoyageSchedulesModel };
